import script from "./de.vue?vue&type=script&lang=js"
export * from "./de.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/i18n/languages/de.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15d8d5bd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15d8d5bd', __exports__)) {
    api.reload('15d8d5bd', __exports__)
  }
  
}


export default __exports__